import { render, staticRenderFns } from "./PreEurekersTab.vue?vue&type=template&id=2ed643a4&scoped=true&"
import script from "./PreEurekersTab.vue?vue&type=script&lang=js&"
export * from "./PreEurekersTab.vue?vue&type=script&lang=js&"
import style0 from "./PreEurekersTab.vue?vue&type=style&index=0&id=2ed643a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed643a4",
  null
  
)

export default component.exports